import { named, optional, withDependencies } from '@wix/thunderbolt-ioc'
import type { Experiments,
	BrowserWindow,
	ICyclicTabbing } from '@wix/thunderbolt-symbols'
import {
	BrowserWindowSymbol,
	ExperimentsSymbol,
	FeatureExportsSymbol,
	SiteServicesManagerSymbol,
	SiteFeatureConfigSymbol,
} from '@wix/thunderbolt-symbols'
import type { IFeatureExportsStore } from 'thunderbolt-feature-exports'
import { name } from './symbols'
import type { CyclicTabbingSiteConfig } from './types'
import { createCyclicTabbing } from '@wix/cyclic-tabbing'
import type { ServicesManager } from '@wix/services-manager/types'
import { CyclicTabbingDefinition } from '@wix/viewer-service-cyclic-tabbing/definition'

export const CyclicTabbing = withDependencies(
	[BrowserWindowSymbol, named(FeatureExportsSymbol, name), ExperimentsSymbol, named(SiteFeatureConfigSymbol, name), optional(SiteServicesManagerSymbol)],
	(
		browserWindow: BrowserWindow,
		cyclicTabbingExports: IFeatureExportsStore<typeof name>,
		experiments: Experiments,
		config: CyclicTabbingSiteConfig,
		servicesManager?: ServicesManager
	): ICyclicTabbing => {
		let enableCyclicTabbing: ICyclicTabbing['enableCyclicTabbing']
		let disableCyclicTabbing: ICyclicTabbing['disableCyclicTabbing']
		const isBuilder = config.isBuilderComponentModel
		const isServicesInfra = experiments['specs.thunderbolt.servicesInfra'] || isBuilder
		if (isServicesInfra && servicesManager?.hasService(CyclicTabbingDefinition)) {
			const cyclicTabbingService = servicesManager?.getService(CyclicTabbingDefinition)
			if (!cyclicTabbingService) {
				throw new Error('CyclicTabbingService is not registered')
			}
			;({ enableCyclicTabbing, disableCyclicTabbing } = cyclicTabbingService)
		} else {
			;({ enableCyclicTabbing, disableCyclicTabbing } = createCyclicTabbing({
				browserWindow: browserWindow as Window,
				screenReaderFocus: !!experiments['specs.thunderbolt.screen_reader_focus'],
			}))
		}

		return {
			enableCyclicTabbing,
			disableCyclicTabbing,
			appWillMount: () => {
				cyclicTabbingExports.export({
					enableCyclicTabbing,
					disableCyclicTabbing,
				})
			},
		}
	}
)
